<template>
  <div class="checkout-delivery__address">
    <div class="form-radio" v-for="(item) in addressMethods">
      <input v-model="selectedMethod" type="radio" :value="item.id" :id="item.id" name="radio-group"
             @change="onSelectedMethodChanged">
      <label :for="item.id">{{ item.name }}</label>
    </div>
    <div v-if="isExisting && userAddresses.length > 1" class="checkout-delivery__address-existing">
      <select v-model="selectedUserAddress" name="" @change="onSelectUserAddress">
        <option :value="0">בחר כתובת</option>
        <option v-for="addr in userAddresses" :key="addr.id" :value="addr.id"><span v-html="addr.address_name_order"></span></option>
      </select>
    </div>
    <div v-show="isFind" class="checkout-delivery__address-find">
      <input ref="findRef" type="text" placeholder="איתור כתובת למשלוח">
    </div>
    <form action="" novalidate>
      <div class="form-inline">
          <div class="floating-input-wrapper">
              <input v-model="address.city" :disabled="isExisting" type="text" class="floating-input" required>
              <span  :class="{
                    'floating-label': true,
                    'label-error': getErrors()['address.city'],
                    'has-value': !!address.street,
                }">
                    עיר
                    <span class="required-star">*</span>
                </span>
          </div>
          <div class="floating-input-wrapper">
              <input v-model="address.street" :disabled="isExisting" type="text" class="floating-input" required>
              <span  :class="{
                    'floating-label': true,
                    'label-error': getErrors()['address.street'],
                    'has-value': !!address.street,
                }">
                    רחוב
                    <span class="required-star">*</span>
                </span>
          </div>
      </div>
      <div class="flex form-inline__inside">
        <div class="form-inline">
           <div class="floating-input-wrapper">
                <input v-model="address.house" :disabled="isExisting" type="text" class="floating-input" required>
                <span  :class="{
                    'floating-label': true,
                    'label-error': getErrors()['address.house'],
                    'has-value': !!address.house,
                }">
                    בית
                    <span class="required-star">*</span>
                </span>
           </div>
            <div class="floating-input-wrapper">
                <input v-model="address.flat" :disabled="isExisting" type="text" class="floating-input" required>
                <span  class="floating-label" :class="{'has-value': !!address.flat}">
                    דירה
                </span>
            </div>
        </div>
        <div class="form-inline">
          <div class="floating-input-wrapper">
                <input v-model="address.entrance" :disabled="isExisting" type="text" class="floating-input" required>
                <span class="floating-label" :class="{'has-value': !!address.entrance}">
                    כניסה
                </span>
          </div>
            <div class="floating-input-wrapper">
                <input v-model="address.floor" :disabled="isExisting" type="text" class="floating-input" required>
                <span class="floating-label" :class="{'has-value': !!address.floor}">
                    קומה
                </span>
            </div>
        </div>
      </div>
      <div v-if="isFind" class="checkout-delivery__address-existing__save">
        <div v-if="isLogged" class="form-check">
          <input type="checkbox" id="saveAddress" name="checkbox-group">
          <label for="saveAddress">שמור כתובת ברשימת הכתובות</label>
        </div>
      </div>
      <textarea v-model="address.comment" placeholder="הערות לאספקה"></textarea>
    </form>
  </div>
</template>

<script>

export default {
  inject: ['getErrors'],
  name: "CheckoutAddress",
  props: ['address'],
  components: {},
  data() {
    return {
      selectedUserAddress: 0,
      userAddresses: [],
      addressMethods: [
        {
          id: 'savedAddress',
          name: 'בחר מכתובות שמורות',
        },
        {
          id: 'findAddress',
          name: 'הזן כתובת',
        },
      ],
      selectedMethod: 'findAddress',
      isLogged: window.isLogged
    }
  },
  computed: {
    addressMethods(){
      return this.userAddresses.length > 0
      ? [
          {
            id: 'savedAddress',
            name: 'בחר מכתובות שמורות',
          },
          {
            id: 'findAddress',
            name: 'הזן כתובת',
          },
        ]
        : [
          {
            id: 'findAddress',
            name: 'הזן כתובת',
          },
        ]
    },
    isExisting() {
      return this.selectedMethod === 'savedAddress'
    },
    isFind() {
      return this.selectedMethod === 'findAddress'
    },
    isAuthorized() {
      return !!window.userAuth;
    }
  },
  mounted() {
    const that = this
    this.load()
    setTimeout(function (){
      that.getUserAddresses()
    }, 500)
  },
  methods: {
    getUserAddresses() {
      if (this.isAuthorized) {
        axios.get(route('client.customer.addresses.list'))
          .then(resp => {
            this.userAddresses = resp.data.addresses
          })
      }
    },
    onSelectUserAddress() {
      const sel = this.userAddresses.find(i => i.id === this.selectedUserAddress)
      if (sel) {
        this.address.city = sel.city;
        this.address.street = sel.street;
        this.address.house = sel.house;
        this.address.flat = sel.flat;
        this.address.floor = sel.floor;
        this.address.entrance = sel.entrance;
      } else{
        this.resetAddress()
      }
    },
    onSelectedMethodChanged() {
      if (this.isExisting) {
        if(!this.selectedUserAddress && this.userAddresses.length === 1){
          this.selectedUserAddress = this.userAddresses[0].id
        }
        this.onSelectUserAddress()
      }
    },
    load() {
      const that = this
      if (window.google?.maps?.places) {
        that.initAutocomplete()
      } else {
        let script = document.createElement('script');
        script.onload = () => {
          that.initAutocomplete();
        };
        script.async = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAAE5BCWKvjVCa60f_OdRV1yl9hKYw4V_Y&libraries=places&language=he';
        document.head.appendChild(script)
      }
    },
    initAutocomplete() {
      const options = {
        componentRestrictions: {country: "il"},
        fields: ["address_components", "geometry", "icon", "name"],
        strictBounds: false,
        types: ["geocode"],
      };
      this.autocomplete = new google.maps.places.Autocomplete(this.$refs.findRef, options);
      this.autocomplete.addListener('place_changed', this.fillAddress);
    },
    fillAddress() {
      const place = this.autocomplete.getPlace()
      const ac = place?.address_components;
      if (ac) {
        for (const item of ac) {
          for (const type of item.types) {
            switch (type) {
              case 'street_number':
                this.address.house = item.short_name
                break;
              case 'route':
                this.address.street = item.long_name
                break;
              case 'locality':
                this.address.city = item.long_name
                break;
            }
          }
        }
      }
    },
    resetAddress() {
      this.address.city = '';
      this.address.street = '';
      this.address.house = '';
      this.address.flat = '';
      this.address.floor = '';
      this.address.entrance = '';
      //this.address.comment = '';
    }
  }
}
</script>

<style scoped>

</style>
